import { camelCase, snakeCase } from 'lodash';

type TObjectType = { [key: string]: unknown };

export class CaseConverter {
  public static toCamelCase(str: string): string {
    return camelCase(str);
  }

  public static toSnakeCase(str: string): string {
    return snakeCase(str);
  }

  public static deeplyConvertKeys(obj: unknown, converter: (key: string) => string): unknown {
    if (Array.isArray(obj)) {
      return obj.map((item) => this.deeplyConvertKeys(item, converter));
    }

    // A Date has no own enumerable keys, so without this guard Object.keys(date) returns []
    // and the reduce below silently turns it into {} - any request body containing a raw Date
    // (rather than an already-stringified one) would lose that field's value entirely.
    if (obj instanceof Date) {
      return obj;
    }

    if (obj !== null && typeof obj === 'object') {
      return Object.keys(obj as object).reduce((result: TObjectType, key: string) => {
        const value = (obj as TObjectType)[key];
        const newKey = converter(key);
        result[newKey] = this.deeplyConvertKeys(value, converter);

        return result;
      }, {});
    }

    return obj;
  }
}
